import { NetsuiteContactsPage } from "./netsuite-contacts/NetsuiteContactsPage";
import { ProspectLetterPage } from "./prospect-letter/ProspectLetterPage";
import { ToolsPage } from "./ToolsPage";

import { ToolsIcon } from "@/components/icons";
import { ROUTES } from "@/config/routes";
import type { FeatureModule } from "@/types/feature";

/** Tools feature registration. This is the public surface of the feature. */
export const toolsFeature: FeatureModule = {
  id: "tools",
  navItems: [
    {
      id: "tools",
      label: "Tools",
      path: ROUTES.tools,
      icon: ToolsIcon,
    },
  ],
  routes: [
    { path: ROUTES.tools, element: <ToolsPage /> },
    { path: ROUTES.prospectLetter, element: <ProspectLetterPage /> },
    { path: ROUTES.netsuiteContacts, element: <NetsuiteContactsPage /> },
  ],
};
